import { z } from 'zod';
// ============================================================
// Studio Bubble (하단탭 신규 안내 말풍선) Schemas
// ============================================================
// web 하단 탭의 'AI 스튜디오' 위에 뜨는 안내 말풍선("NEW 제주스냅").
// 신규 컨셉이 나올 때마다 배포하지 않도록 문구와 노출 여부를 admin에서 편집한다.
// 한 번 닫으면 그 세션 동안 다시 뜨지 않는 동작(sessionStorage)은 클라이언트가 그대로 유지한다.
export const StudioBubbleConfigSchema = z.object({
    /** 노출 여부 — 이벤트가 끝나면 배포 없이 여기서 끈다 */
    enabled: z.boolean(),
    /** 좌측 배지 문구. 비우면 배지 자체를 렌더하지 않는다 */
    badge: z.string().max(10, '배지는 10자를 초과할 수 없습니다'),
    /** 본문 문구. 말풍선이 탭 하나 폭에 얹히므로 짧게 */
    text: z.string().max(20, '문구는 20자를 초과할 수 없습니다'),
});
/** 기본값 — 설정 키가 없거나 깨졌을 때 폴백. 현재 운영 중인 문구와 동일하다 */
export const DEFAULT_STUDIO_BUBBLE_CONFIG = {
    enabled: true,
    badge: 'NEW',
    text: '제주스냅',
};
/** appSettings 키 — api/admin 양쪽이 같은 문자열을 쓰도록 여기서 내보낸다 */
export const STUDIO_BUBBLE_SETTING_KEY = 'studio_bubble_config';
//# sourceMappingURL=studioBubble.js.map